var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "footer",
    [
      _c("cookie-law", { attrs: { theme: "cityhub", buttonText: "Aceito" } }, [
        _c(
          "div",
          { attrs: { slot: "message" }, slot: "message" },
          [
            _vm._v(
              "\n          Este website utiliza cookies. Ao continuar a navegação está a aceitar a sua utilização. Caso pretenda saber mais,\n          consulte a nossa "
            ),
            _c(
              "router-link",
              { attrs: { to: _vm.routerLink(_vm.getSlugPageType("privacy")) } },
              [_vm._v("política de privacidade")]
            ),
            _vm._v(".\n      "),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }